import { ICountryStrings } from '../types';

export const COUNTRY_STRINGS: ICountryStrings = {
  AD: _TL_('Andorra'),
  AL: _TL_('Albania'),
  AR: _TL_('Argentina'),
  AT: _TL_('Austria'),
  AU: _TL_('Australia'),
  AW: _TL_('Aruba'),
  BA: _TL_('Bosnia and Herzegovina'),
  BD: _TL_('Bangladesh'),
  BG: _TL_('Bulgaria'),
  BN: _TL_('Brunei'),
  BO: _TL_('Bolivia'),
  BR: _TL_('Brazil'),
  BS: _TL_('Bahamas'),
  CA: _TL_('Canada'),
  CH: _TL_('Switzerland'),
  CL: _TL_('Chile'),
  CO: _TL_('Colombia'),
  CR: _TL_('Costa Rica'),
  CY: _TL_('Cyprus'),
  CZ: _TL_('Czech Republic'),
  DE: _TL_('Germany'),
  DK: _TL_('Denmark'),
  DM: _TL_('Dominica'),
  DO: _TL_('Dominican Republic'),
  EC: _TL_('Ecuador'),
  EE: _TL_('Estonia'),
  ES: _TL_('Spain'),
  FI: _TL_('Finland'),
  FJ: _TL_('Fiji'),
  FR: _TL_('France'),
  GB: _TL_('United Kingdom'),
  GF: _TL_('French Guiana'),
  GR: _TL_('Greece'),
  GT: _TL_('Guatemala'),
  GU: _TL_('Guam'),
  GY: _TL_('Guyana'),
  HK: _TL_('Hong Kong SAR'),
  HN: _TL_('Honduras'),
  HR: _TL_('Croatia'),
  HT: _TL_('Haiti'),
  HU: _TL_('Hungary'),
  ID: _TL_('Indonesia'),
  IE: _TL_('Ireland'),
  IN: _TL_('India'),
  IS: _TL_('Iceland'),
  IT: _TL_('Italy'),
  JP: _TL_('Japan'),
  KY: _TL_('Cayman Islands'),
  LI: _TL_('Liechtenstein'),
  LK: _TL_('Sri Lanka'),
  LT: _TL_('Lithuania'),
  LU: _TL_('Luxembourg'),
  LV: _TL_('Latvia'),
  MC: _TL_('Monaco'),
  ME: _TL_('Montenegro'),
  MK: _TL_('North Macedonia'),
  MN: _TL_('Mongolia'),
  MQ: _TL_('Martinique'),
  MS: _TL_('Montserrat'),
  MT: _TL_('Malta'),
  MV: _TL_('Maldives'),
  MX: _TL_('Mexico'),
  MY: _TL_('Malaysia'),
  NC: _TL_('New Caledonia'),
  NL: _TL_('Netherlands'),
  NO: _TL_('Norway'),
  NP: _TL_('Nepal'),
  NZ: _TL_('New Zealand'),
  PA: _TL_('Panama'),
  PE: _TL_('Peru'),
  PF: _TL_('French Polynesia'),
  PG: _TL_('Papua New Guinea'),
  PH: _TL_('Philippines'),
  PL: _TL_('Poland'),
  PR: _TL_('Puerto Rico'),
  PT: _TL_('Portugal'),
  PY: _TL_('Paraguay'),
  RO: _TL_('Romania'),
  RS: _TL_('Serbia'),
  SE: _TL_('Sweden'),
  SG: _TL_('Singapore'),
  SI: _TL_('Slovenia'),
  SK: _TL_('Slovakia'),
  SM: _TL_('San Marino'),
  SV: _TL_('El Salvador'),
  TH: _TL_('Thailand'),
  TR: _TL_('Turkey'),
  TT: _TL_('Trinidad and Tobago'),
  TW: _TL_('Taiwan'),
  US: _TL_('United States'),
  UY: _TL_('Uruguay'),
  VA: _TL_('Vatican'),
  VE: _TL_('Venezuela'),
  VN: _TL_('Vietnam'),
  ZA: _TL_('South Africa'),
  CD: _TL_('Democratic Republic of the Congo'),
  ET: _TL_('Ethiopia'),
  GN: _TL_('Guinea'),
  LS: _TL_('Lesotho'),
  MG: _TL_('Madagascar'),
  MW: _TL_('Malawi'),
  MR: _TL_('Mauritania'),
  MU: _TL_('Mauritius'),
  NA: _TL_('Namibia'),
  NG: _TL_('Nigeria'),
  RE: _TL_('Reunion'),
  SC: _TL_('Seychelles'),
  TZ: _TL_('Tanzania'),
  GM: _TL_('Gambia'),
  TG: _TL_('Togo'),
  ZW: _TL_('Zimbabwe'),
  DZ: _TL_('Algeria'),
  AM: _TL_('Armenia'),
  AZ: _TL_('Azerbaijan'),
  BH: _TL_('Bahrain'),
  EG: _TL_('Egypt'),
  GE: _TL_('Georgia'),
  IQ: _TL_('Iraq'),
  IL: _TL_('Israel'),
  KG: _TL_('Kyrgyzstan'),
  LY: _TL_('Libya'),
  MD: _TL_('Moldova'),
  OM: _TL_('Oman'),
  PK: _TL_('Pakistan'),
  QA: _TL_('Qatar'),
  SA: _TL_('Saudi Arabia'),
  TJ: _TL_('Tajikistan'),
  AE: _TL_('United Arab Emirates'),
  YE: _TL_('Yemen'),
  CM: _TL_('Cameroon'),
  CG: _TL_('Republic of the Congo'),
  CI: _TL_('Republic of Côte d’Ivoire'),
  RW: _TL_('Rwanda'),
  SN: _TL_('Senegal'),
  SO: _TL_('Somalia'),
  UG: _TL_('Uganda'),
  ZM: _TL_('Zambia'),
  BW: _TL_('Botswana'),
  GA: _TL_('Gabon'),
  TN: _TL_('Tunisia'),
  BJ: _TL_('Benin'),
  BF: _TL_('Burkina Faso'),
  NE: _TL_('Niger'),
  AS: _TL_('American Samoa'),
  AI: _TL_('Anguilla'),
  BM: _TL_('Bermuda'),
  VG: _TL_('British Virgin Islands'),
  GI: _TL_('Gibraltar'),
  MP: _TL_('Northern Mariana Islands'),
  TC: _TL_('Turks and Caicos Islands'),
  VI: _TL_('U.S. Virgin Islands'),
  BB: _TL_('Barbados'),
  BZ: _TL_('Belize'),
  GD: _TL_('Grenada'),
  JM: _TL_('Jamaica'),
  MH: _TL_('Marshall Islands'),
  KN: _TL_('Saint Kitts and Nevis'),
  LC: _TL_('Saint Lucia'),
  VC: _TL_('Saint Vincent and the Grenadines'),
  SR: _TL_('Suriname'),
  TO: _TL_('Tonga'),
  GL: _TL_('Greenland'),
  FO: _TL_('Faroe Islands'),
  AG: _TL_('Antigua and Barbuda'),
  CC: _TL_('Cocos Islands'),
  CF: _TL_('Central African Republic'),
  CK: _TL_('Cook Islands'),
  CX: _TL_('Christmas Island'),
  DJ: _TL_('Djibouti'),
  ER: _TL_('Eritrea'),
  GP: _TL_('Guadeloupe'),
  GW: _TL_('Guinea-Bissau'),
  KM: _TL_('Comoros'),
  NF: _TL_('Norfolk Island'),
  NR: _TL_('Nauru'),
  NU: _TL_('Niue'),
  PM: _TL_('Saint Pierre and Miquelon'),
  PN: _TL_('Pitcairn'),
  PW: _TL_('Palau'),
  SL: _TL_('Sierra Leone'),
  TK: _TL_('Tokelau'),
  TV: _TL_('Tuvalu'),
  VU: _TL_('Vanuatu'),
  WF: _TL_('Wallis and Futuna'),
  WS: _TL_('Samoa'),
  YT: _TL_('Mayotte'),
  MO: _TL_('Macao SAR'),
  BE: _TL_('Belgium'),
};
